import { AIInterviewManager } from './AIInterviewManager';

export function DashboardLayout() {
  return <AIInterviewManager />;
}
